import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Mutations} from "@/store/enums/store.enums";
import {FaqActions, FaqMutation} from "@/modules/faq/store/enums";

@Module
export default class Store extends VuexModule {
    renderKey = 1;

    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };

    listCache = [];
    listTotal = 0;

    activeType = 'faqCategories';

    get getFaqRenderKey() {
        return 'faq-' + this.renderKey;
    }

    get getFaqLastListResult() {
        return this.listCache;
    }

    get getFaqLastListTotal() {
        return this.listTotal;
    }

    get getFaqActiveType() {
        return this.activeType;
    }

    @Mutation
    [FaqMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [FaqMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Mutation
    [FaqMutation.SET_ACTIVE_TYPE](tabName) {
        this.activeType = tabName;
    }

    @Action
    [FaqActions.REFRESH_LIST]() {
        this.context.dispatch(FaqActions.FETCH_LIST, this.listParams);
    }

    @Action
    [FaqActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("services/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(FaqMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`services/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('services/create/', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FaqActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`services/edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FaqActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.DELETE_ITEM](detailId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`services/delete/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(FaqActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.UPDATE_TRANSLATION](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`services/update-translation/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.GET_GROUP_TREE](groupId) {

        return new Promise((resolve, reject) => {

            apiService.get(`services/get-group-tree/${groupId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.ASSIGN_TO_GROUP](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("services/assign-to-group/", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.REMOVE_FROM_GROUP](toGroupId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`services/remove-from-group/${toGroupId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [FaqActions.REORDER_GROUP](payload) {

        return new Promise((resolve, reject) => {

            const {groupId} = payload;

            apiService.put(`services/reorder-group/${groupId}`, payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
